import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';
import { TamigoSetupRequest } from '@/models/payment';
import { useAppDispatch } from '@/lib/hooks';
import { setLoader } from '@/lib/slices/globalLoaderSlice';
import { usePaymentsMutations } from '@/services/paymentsMutations';
import {} from '@/services/paymentsQuery';
import { TwoInputConnection } from '@/pages/company/common/TwoInputConnection';
interface TamigoConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
}

export const TamigoConnect = (props: TamigoConnectProps) => {
    const { t } = useTranslation();
    const [tamigoData, setTamigoData] = useState<TamigoSetupRequest>({} as any);
    const { setAlert } = useNotificationsSnackbar();

    const { setupTamigo } = usePaymentsMutations();

    const dispatch = useAppDispatch();

    const onClick = () => {
        setupTamigo.mutate({
            applicationName: tamigoData?.applicationName,
            apiKey: tamigoData?.apiKey
        });
    };

    useEffect(() => {
        if (setupTamigo.isSuccess) {
            props.onSaveSuccess();
        }
    }, [setupTamigo.isSuccess]);

    useEffect(() => {
        if (setupTamigo.isError) {
            setAlert('Connection failed', 'error');
        }
    }, [setupTamigo.isError]);

    useEffect(() => {
        dispatch(setLoader(setupTamigo.isPending));
    }, [setupTamigo.isPending]);

    return (
        <>
            <TwoInputConnection
                input1Value={tamigoData?.applicationName}
                input2Value={tamigoData?.apiKey}
                input1Label={t('tamigo_app_name')}
                input2Label={t('tamigo_api_key')}
                input1Placeholder={t('')}
                input2Placeholder={t('')}
                input1OnChange={(val: any) => {
                    setTamigoData({
                        ...tamigoData,
                        applicationName: val.target.value
                    });
                }}
                input2OnChange={(val) => {
                    setTamigoData({
                        ...tamigoData,
                        apiKey: val.target.value
                    });
                }}
                primaryDisabled={
                    !tamigoData.applicationName || !tamigoData?.applicationName
                }
                primaryButtonTitle={t('connect')}
                secondaryButtonTitle={t('cancel')}
                onClickPrimary={onClick}
                onClickSecondary={() => {
                    props.onClose?.();
                }}
            />
        </>
    );
};
